<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                    <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
                    <headSide v-else @release="gorelease()"></headSide>
                    <div class="mt-20">
                        <div class="mt-30">
                            <div class="menant">
                                <div class="fsc">
                                <span class="lines"></span>
                                <span class="fawer_text">我的收藏</span>
                                </div>
                                <div class="store_lewar fsb">
                                    <p v-for="(item,index) in listSide"
                                    :class="[active == index?'active_coler ml-20':'ml-20']"
                                    :key="index" @click.prevent="onHide(item)">{{item.text}}</p>
                                </div>
                            </div>
                            <div class="faver">
                                <span @click.prevent="onRemove()">删除</span>
                                <span @click.prevent="wholeRemove()">全部删除</span>
                                <span @click.prevent="onCancel()">取消</span>
                            </div>
                             <!--产品-->
                             <div v-if="content == '产品' " class="collect_mater">
                                <div  class="collect_may fdcc" v-for="(cont,index) in list" :key="index"  >
                                    <div class="product_box"  @click="onView(cont)">
                                        <img class="prod_img" :src="cont.goodsPic">
                                    </div>
                                    <span   class="product_name">{{cont.title}}</span>
                                     <div class="fcc place ">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="cont.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>

                             </div>
                            <!--企业-->
                             <div v-if="content == '企业' " class="collect_mater">
                                <div  class="collect_may fdcc" v-for="(items,index) in list" :key="index" >
                                    <div class="product_box" @click="onView(items)">
                                        <img class="prod_img" :src="items.goodsPic">
                                    </div>
                                    <span class="collect_name">{{items.name}}</span>
                                    <div class="fcc place">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="items.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>

                             </div>
                            <!--需求-->
                             <div v-if="content == '需求' " class="fdw">
                                <div  class="w48 fdc" v-for="(deman,index) in list" :key="index"  >
                                    <div class="place mt-15">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="deman.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="demand_box" @click="onView(deman)">
                                        <p>{{deman.title}}</p>
                                        <p class="mt-15">{{deman.collectionDateStr}}</p>
                                    </div>
                                </div>

                             </div>
                             <!--资料-->
                             <div v-if="content == '资料'" class="fdw">
                                 <div  class="w48 fdc" v-for="(means,index) in list" :key="index" >
                                    <div class="place mt-15">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="means.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="detail_box fdc" @click="onView(means)">
                                        <div>
                                            <img src="../../assets/images/download_1.jpg"  alt="">
                                        </div>
                                        <div class="f1 ml-20">
                                             <p class="text_over">{{means.title}}</p>
                                             <p  style="max-width: 14em;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"  class="mt-15">{{means.describe}}</p>
                                        </div>
                                    </div>
                                 </div>

                             </div>
                             <!--课程-->
                             <div v-if="content == '课程'" class="fdw">
                                 <div  class="w48 fdc" v-for="(curr,index) in list" :key="index" >
                                    <div class="fcc place mt-15">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="curr.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="curric_box fsb" @click="onView(curr)">
                                        <div class="curric_img">
                                            <img :src="curr.goodsPic" alt="">
                                        </div>
                                        <div class="curric_cox">
                                             <p class="curric_title">{{curr.name}}</p>
                                             <p class="mt-15 f13">
                                                 <span>收藏时间 :</span>
                                                 <span>{{curr.collectionDate.substring(0,10)}}</span>
                                             </p>
                                        </div>
                                    </div>
                                 </div>
                             </div>
                             <!--专家-->
                             <div v-if="content == '专家'" class="fdw">
                                 <div  class="w48 fdc" v-for="(expert,index) in list" :key="index">
                                    <div class="fcc place">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="expert.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="meacl_box fsb" @click="onView(expert)">
                                        <div class="meacl_box_img">
                                            <img :src="expert.goodsPic" alt="">
                                        </div>
                                        <div class="meacl_cox">
                                             <p class="f18">{{expert.name}}</p>
                                             <p class="f14 mt-10">{{expert.workPlace}}</p>
                                             <p class="expert_job  f14 mt-10" v-if="expert.job">{{expert.job.replace(new RegExp("/","gm"),"")}}</p>
                                        </div>
                                    </div>
                                 </div>
                             </div>
                             <!--资讯-->
                             <div v-if="content == '资讯'" class="fdw">
                                 <div  class="w48 fdc" v-for="(info,index) in list" :key="index">
                                   <div class="fcc place mt-15">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="info.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="curric_box fsb" @click="onView(info)">
                                        <div class="curric_img">
                                            <img :src="info.goodsPic" alt="">
                                        </div>
                                        <div class="curric_cox">
                                             <p class="curric_title">{{info.title}}</p>
                                             <p class="mt-15 f13">
                                                 <span>收藏时间 :</span>
                                                 <span>{{info.collectionDateStr}}</span>
                                             </p>
                                        </div>
                                    </div>
                                 </div>
                             </div>
                             <!--技术-->
                             <div v-if="content == '技术'" class="fdw">
                                 <div  class="w48 fdc" v-for="(info,index) in list" :key="index">
                                   <div class="fcc place mt-15">
                                       <el-checkbox-group v-model="checkList" @change="onChange">
                                            <el-checkbox :label="info.id"></el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="curric_box fsb" @click="onView(info)">
                                        <div class="curric_img">
                                            <img :src="info.goodsPic" alt="">
                                        </div>
                                        <div class="curric_cox">
                                             <p class="curric_title">{{info.title}}</p>
                                             <p class="mt-15 f13">
                                                 <span>收藏时间 :</span>
                                                 <span>{{info.collectionDateStr}}</span>
                                             </p>
                                        </div>
                                    </div>
                                 </div>
                             </div>
                        </div>
                        <!--分页-->
                         <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>

                        <div style="margin-top:20%;">
                            <notList :notCode="notCode"></notList>
                        </div>

                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {collectionList,delCollection} from '@/api/coment'
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import { formatTime } from '../../utils'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
  components:{
     sidebar,headSide,companySide,commBanner,titleHead,Pagination,notList
  },
  data(){
      return{
        headTitle:'我的收藏',
        obj:{
            title:'我的收藏',
            contCount:'',
            isShow:false,
            roleType:'',
            personalType:9
        },
        listSide:[
            {'text':'产品',index:0,type:6},
            {'text':'企业',index:1,type:7},
            {'text':'需求',index:2,type:8},
            {'text':'资料',index:3,type:1},
            {'text':'课程',index:4,type:4},
            {'text':'专家',index:5,type:9},
            {'text':'资讯',index:6,type:2},
            {'text':'技术',index:7,type:3}
            ],
        active:0,
        content:'产品',
        checkList:[],
        listQuery:{
          curPage:1,
          limit:8,
          goodsType:6
         },
        list:[],
        total:0,//总条数
        ids:[],
        id:'',
        notCode:false,
        type:false,
        isButton:false
      }
  },
  created(){
      this.getList();
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
      if(type == 3){
         this.type = true;
         this.headTitle = '企业收藏';
         this.obj.title = '企业收藏';
      }
  },
  methods:{
      handleClick(tab, event) {},
      //详情
      onView(data){
        switch(this.active){
            case 0:
                this.$router.push({
                path:'/supply_detail',
                query:{id:data.goodsId}
                });
                break;
            case 1:
                sessionStorage.setItem("corporateId", data.goodsId);
                this.$store.dispatch("company/getBaseInfo");
                this.$router.push({
                path:'/corporate_detail',
                query:{id:data.goodsId}
                });
                break;
            case 2:
                this.$router.push({
                path:'/demand_detail',
                query:{id:data.goodsId}
                });
                break;
            case 3:
                this.$router.push({
                path:'/data_detail',
                query:{id:data.goodsId}
                });
                break;
            case 4:
                this.$router.push({
                path:'/curriculumDetail',
                query:{id:data.goodsId}
                });
                break;
            case 5:
                this.$router.push({
                path:'/expert_detail',
                query:{id:data.goodsId}
                });
                break;
            case 6:
                this.$router.push({
                path:'/info_detail',
                query:{id:data.goodsId}
                });
                break;
            case 7:
                this.$router.push({
                path:'/technology_detail',
                query:{id:data.goodsId}
                });
                break;
            default:
                break;
        }


      },
      //切换内容
      onHide(item){
          this.active = item.index;
          this.content = item.text;
          this.listQuery.goodsType = item.type;
          this.getList();
          this.checkList = [];
      },
       //获取产品列表
      getList(){
        collectionList(this.listQuery).then((res)=>{
            if(res.code ==0){
              this.list = res.page.list;
              this.total = res.page.totalCount;
			  this.list.length == 0 ? this.notCode = true : this.notCode = false;
            }
        }).catch((err)=>{});
      },
       //选中
      onChange(){
        this.checkList.forEach(item =>{
            this.ids.push(item);
        });
      },
      //删除
      delColle(){
         if(this.checkList.length == 0){
            this.$message({
              message:'至少选择一条数据',
              type:'info',
              duration:1000
            })
          }else{
           let params ={
               ids: this.checkList.toString()
           };
            this.$confirm('确定要删除吗','提示',{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(()=>{
            delCollection(params).then((res)=>{
                if(res.code ==0){
                this.$message({
                    message:'删除成功！',
                    type: 'success',
                    duration:1000,
                    onClose:()=>{
                    this.getList();
                    }
                });
                }
            }).catch((err)=>{})
          }).catch(()=>{
            this.$message({
                type: 'info',
                message: '已取消删除'
             });
          });
          }




      },
      //单个或者多个
      onRemove(){
        this.delColle();
      },
      //全部删除
      wholeRemove(){
        if(this.list.length == 0){
         this.$message({
            message:'没有数据哦',
            type:'info',
            duration:1000
         })
        }else{
         this.list.forEach(item=>{
            this.checkList.push(item.id)
          });
          this.delColle();
        }
      },
      //取消
      onCancel(){
        this.checkList =[];
      },
       //分页
      pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
        this.getDemandList();
     },
     //发布需求
     gorelease(){
       this.$router.push('/demand')
     }
  }
}
</script>
<style scoped>
.fdcc{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.fwd{
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
.collect_mater{
  	display: flex;
	justify-content:flex-start;
	flex-wrap: wrap;
}
/* .collect_mater:after{
  content: '';
  width: 155px;
} */
.text_over{
   overflow: hidden;
/*   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2; */
   text-overflow: ellipsis;
   white-space: nowrap;
   width: 90%;
}
.fsb{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
.ml-20{
    margin-left: 20px;
}
.mt-20{
    margin-top: 20px;
}
.mt-10{
    margin-top: 10px;
}
.mt-15{
  margin-top: 15px;
}
.f1{
    flex: 1;
}
.f13{
    font-size: 13px;
    font-family: Microsoft YaHei;
}
.f14{
    font-size: 14px;
    font-family: Microsoft YaHei;
}
.f18{
    font-size: 18px;
    font-weight: 400;
    font-family: Microsoft YaHei;
}
.line{
  width: 5px;
  height: 23px;
  background: #FF7302;
  display: inline-block;
}
.needs_text{
  margin-left: 15px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.product_box{
    width: 100%;
    overflow: hidden;
	height: 140px;
    border: 1px solid #EBEBEB;
}
.prod_img{
    width: 100%;
    height: 100%;
    transition: all 0.6s;
}
.prod_img:hover{
    transform: scale(1.1);
}
.product_name{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 5px;
    text-align: left;
    height: 42px;
    overflow: hidden;
}
.paging{
    margin-top: 30px;
}
.faver{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* height: 20px; */
    margin: 10px 0px;
}
.faver span{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    padding: 0px 10px;
}
.faver span:hover{
    cursor: pointer;
}
.menant{
    position: relative;
}
.store_lewar{
    position: absolute;
    top: 2px;
    left: 120px;
}
.store_lewar p{
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    padding-bottom: 5px;
    color: #333333;
}
.store_lewar p:hover{
    cursor: pointer;
}
.active_coler{
   border-bottom: 2px solid #FF7302;
}
.collect_may{
    width: 22%;
    margin-bottom: 20px;
    margin-right: 20px;
}
.collect_name{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.w48{
    width: 48%;
    /* height: 110px; */
    margin-bottom: 20px;
}
.demand_box{
    background: #fbfbfb;
    width: 91%;
    border: 1px solid #DCDCDC;
    text-align: left;
    height: 110px;
    padding: 14px  20px;
}
.demand_box p:nth-child(1){
   overflow: hidden;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 2;
   height: 48px;
   font-size: 15px;
}
.detail_box{
	background: #fbfbfb;
	width: 91%;
	border: 1px solid #DCDCDC;
	text-align: left;
	height: 110px;
	padding: 14px  20px;
}
.demand_box p:nth-child(2){
    font-size: 14px;
    font-family: Microsoft YaHei;
}
.curric_box{
   width: 91%;
   border: 1px solid #DCDCDC;
   text-align: left;
   height: 128px;
}
.curric_img{
    width: 40%;
    overflow: hidden;
}
.curric_img img{
    /* width: 40%; */
    /* width: 149px; */
    width: 100%;
    height: 126px;
    transition: all 0.6s;
}
.curric_img img:hover{
    transform: scale(1.4);
}
.curric_cox{
    width: 60%;
    display: flex;
    flex-direction: column;
    padding: 10px 12px;
}
.curric_title{
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 5px;
	height: 60px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3
}

.meacl_box{
   width: 91%;
   border: 1px solid #DCDCDC;
   text-align: left;
   height: 120px;
}
.meacl_box_img{
    width: 40%;
    overflow: hidden;
}
.meacl_box_img img{
   width: 79%;
   height: 94px;
   margin-top: 12px;
   margin-left: 15px;
   border-radius: 50%;
    transition: all 0.5s;
}
.meacl_box_img img:hover{
   transform: scale(1.1);
   cursor: pointer;
}
.meacl_cox{
    padding: 15px 10px;
	width: 60%;
}
.expert_job{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 41px;
}

.w48>>>.el-checkbox-group{
   margin-left: 10px;
}
.w48>>>.el-checkbox__label{
    display: none;
}
.collect_may>>>.el-checkbox__label{
  display: none;
}
.place>>> .el-checkbox__inner {
  border-radius: 50%;
  width: 18px !important;
  height: 18px !important;
  border: 1px solid #50b035;
}
.place>>> .el-checkbox__inner:after{
    height: 11px;
    left: 6px;
    top: 1px;
    width: 3px;
}
.place >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #50b035;
}

.place >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #50b035;
  border-color: #50b035;
  border-radius: 50%;
}
.place >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #50b035;
}
.place >>> .el-checkbox__inner:hover {
  background-color: #50b035;
}



/**按钮样式 */
.detail_btn{
   width: 15px;
   height: 15px;
   line-height: 15px;
   border-radius: 50%;
   border: 1px solid #DCDFE6;
}
.detail_selected{
    background: url('../../assets/images/checked.png') no-repeat;
    background-size: 98%;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/collection.vue